import type { BillingAdminOperation } from "../capabilities.ts";

export type AdminBillingOperation = BillingAdminOperation;

export const ADMIN_BILLING_OPERATIONS = [
	"admin.connections.materialize",
	"admin.reconciliation.run",
	"admin.reconciliation.retry",
	"admin.webhooks.reconcile",
	"admin.webhooks.verify",
	"admin.webhooks.status",
	"admin.ingestion.health",
	"admin.conflicts.resolve",
] as const satisfies readonly AdminBillingOperation[];

export const ADMIN_OP = {
	conflictsResolve: "admin.conflicts.resolve",
	connectionsMaterialize: "admin.connections.materialize",
	ingestionHealth: "admin.ingestion.health",
	reconciliationRetry: "admin.reconciliation.retry",
	reconciliationRun: "admin.reconciliation.run",
	webhooksReconcile: "admin.webhooks.reconcile",
	webhooksStatus: "admin.webhooks.status",
	webhooksVerify: "admin.webhooks.verify",
} as const satisfies Record<string, AdminBillingOperation>;

export function isAdminBillingOperation(
	operation: string,
): operation is AdminBillingOperation {
	return (ADMIN_BILLING_OPERATIONS as readonly string[]).includes(operation);
}
